import { Card, CardContent, CardHeader, Divider, Grid, IconButton, Tooltip, Typography, } from "@material-ui/core";
import { Link } from "@material-ui/icons";
import React, { Fragment } from "react";
import { userRendererStyles } from "./useRendererStyles";
export const TotalCountTile = ({ tile, navigate }) => {
    const classes = userRendererStyles();
    return (React.createElement(Grid, { item: true, xs: 12, xl: 2, lg: 3, md: 4 },
        React.createElement(Card, { className: classes.root },
            React.createElement(CardHeader, { action: React.createElement(Tooltip, { title: `View list of ${tile.title}` },
                    React.createElement(IconButton, { onClick: () => navigate && navigate(tile.filterUrl) },
                        React.createElement(Link, null))), title: React.createElement(Typography, { variant: "body1", className: classes.cardHeading }, tile.title), className: classes.header }),
            React.createElement(Divider, null),
            React.createElement(CardContent, null,
                React.createElement(Grid, { container: true }, tile.parsedData.map((data, index) => {
                    return (React.createElement(Fragment, { key: index },
                        data.title === "Yesterday" ? (React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(Typography, { variant: "body2", className: classes.centerHeader },
                                data.value,
                                " ",
                                data.title))) : null,
                        data.title === "Today" ? (React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(Typography, { variant: "h2", className: classes.centerHeaderMain }, data.value))) : null,
                        data.title === "Same day last week" ? (React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(Typography, { variant: "body2", className: classes.centerHeader },
                                data.value,
                                " ",
                                data.title))) : null));
                }))))));
};
